import React from 'react';

export const ClockIcon = () => (
    <svg width="22" height="22" viewBox="0 0 256 256" aria-hidden="true" style={{ flex: '0 0 22px', marginTop: 1 }}>
        <circle cx="128" cy="128" r="96" fill="none" stroke="rgb(87,88,111)" strokeWidth="14" />
        <polyline
            points="128 72 128 128 168 152"
            fill="none"
            stroke="rgb(87,88,111)"
            strokeWidth="14"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
